<template>
  <div>
    <b-modal
      id="edit-ticket-modal"
      ref="edit-ticket-modal"
      size="md"
      @hidden="cancel"
      :title="$t('modals.clotureTicket.text')"
    >
      <!-- Date -->
      <div class="row">
        <div class="col-12 col-lg-12" data-app>
          <label for="cause">{{$t("modals.causes.text")}}</label>
          <v-select
            id="cause"
            v-model="ticketCloture.causes"
            :items="causesList"
            :menu-props="{ maxHeight: '200' }"
            item-text="text"
            item-value="value"
            multiple
          ></v-select>
          <b-form-invalid-feedback>
            {{ err.causes }}
          </b-form-invalid-feedback>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="edit(ok)">
              {{$t("buttons.cloture.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["ticket", 'ticketCauses'],
  created() {},
  data() {
    return {
      ticketCloture: {
        causes: null,
        status: "CLOSED",
      },
      err: {
        causes: null,
      },
      causesList: [{ value: null, text: this.$t("titles.causes.text"), disabled: true }],
    };
  },
  watch: {
    ticket(newVal) {
      this.ticketCloture = {
        ticketId: newVal.id,
        causes: null,
        status: "CLOSED",
      };
    },
    ticketCauses(newVal) {
      let causesData = newVal;
      causesData.map((obj) => {
          this.causesList.push({ value: obj.id, text: obj.name });
      });
    },
  },
  methods: {
    cancel() {
      this.clear();
    },
    clear() {
      /* this.ticketCloture = {
        ticketId: null,
        name: null,
      }; */
      this.err = {
        name: null,
      };
    },
    edit(ok) {
      if (!this.ticketCloture.causes) this.err.causes = this.$t("msgError.obligField.text");
      else this.err.causes = "";

      if (!this.err.causes) {
        ok();
        this.$emit("clotureTicket", this.ticketCloture);
      }
    },
  },
};
</script>